import { Component } from '@angular/core';
import { COLUMNS_HEADER_JOB_EXECUTIONS_ADMIN } from '../../../core/constants/tables.constants';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { JobsService } from '../../../core/services/jobs.service';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { GenericTableComponent } from '../../../components/generic-table/generic-table.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-job-detail',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule, SpinnerComponent, GenericTableComponent, FontAwesomeModule],
  templateUrl: './job-detail.component.html',
  styleUrl: './job-detail.component.scss'
})
export class JobDetailComponent {
  COLUMNS_HEADER = COLUMNS_HEADER_JOB_EXECUTIONS_ADMIN;

  job: any;
  jobExecutions: any;

  isLoading = true;
  faSpinner = faSpinner;
  isUpdateLoading = false;

  form: FormGroup = this.formBuilder.group({
    code: ['', Validators.required],
    name: ['', Validators.required],
    description: ['', Validators.required],
    is_active: [false, Validators.required],
  });

  constructor(
    private jobsSvc: JobsService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.getJob();
  }

  onSave() {
    if (this.form.valid) {
      this.isUpdateLoading = true;
      this.jobsSvc.updateJob(this.job.code, this.form.value).subscribe(() => {
        this.isUpdateLoading = false;
      });
    }
  }

  runJob() {
    this.isLoading = true;
    this.jobsSvc.runJob(this.job.code).subscribe((res: any) => {
      this.getJobExecutions(this.job.code);
    });
  }

  private getJob() {
    const jobCode = this.route.snapshot.paramMap.get('code');
    this.jobsSvc.getJob(jobCode).subscribe((res: any) => {
      this.job = res;
      this.form.patchValue(res);
      this.getJobExecutions(jobCode);
    });
  }

  private getJobExecutions(jobCode: any) {
    this.jobsSvc.getJobExecutions(jobCode).subscribe((jobExecutions: any) => {
      this.jobExecutions = jobExecutions;
      this.isLoading = false;
    });
  }

}
